import React, { FC, ReactNode } from 'react';
import classes from './Checkbox.module.css';

interface CheckboxProps {
	label?: string | ReactNode;
	onChange: any;
	checked?: boolean;
}

const Checkbox: FC<CheckboxProps> = ({ label, onChange, checked }) => {
	return (
		<label className={classes.container}>
			{label ? label : null}
			<input type="checkbox" onClick={onChange} checked={checked} />
			<span className={classes.checkmark} />
		</label>
	);
};

export default Checkbox;
